import { TrendingUp } from "lucide-react";
import { Input } from "@/components/ui/input";
import { StartupFilters } from "./StartupFilters";

interface StartupSearchProps {
  search: string;
  onSearchChange: (value: string) => void;
  filters: {
    stage: string[];
    continent: string[];
    teamSize: string[];
    isPro: boolean | null;
    category: string[];
  };
  onFilterChange: (key: string, value: any) => void;
}

export function StartupSearch({ 
  search, 
  onSearchChange, 
  filters, 
  onFilterChange 
}: StartupSearchProps) {
  return (
    <div className="flex flex-col gap-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <TrendingUp className="h-6 w-6 text-flux-cyan mr-2" />
          <h2 className="text-2xl font-bold text-flux-cyan">Latest</h2>
        </div>
      </div>
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <Input
          placeholder="Search startups..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full lg:w-64"
        />
        <StartupFilters
          filters={filters}
          onFilterChange={onFilterChange}
        />
      </div>
    </div>
  );
}